import script from "./DealingOnline.vue?vue&type=script&setup=true&lang=ts"
export * from "./DealingOnline.vue?vue&type=script&setup=true&lang=ts"

import "./DealingOnline.vue?vue&type=style&index=0&id=6998976b&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6998976b"]])

export default __exports__